import ThDrawer from './thdrawer.vue'
ThDrawer.install = Vue => Vue.component(ThDrawer.name, ThDrawer)
export default ThDrawer



// WEBPACK FOOTER //
// ./src/packages/drawer/index.js